import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

const createApolloClient = (graphqlUrl: string, getToken: () => Promise<string | undefined>) => {
  const httpLink = createHttpLink({
    uri: graphqlUrl,
  });

  const authLink = setContext(async (_, { headers }) => {
    try {
      const token = await getToken();
      
      return {
        headers: {
          ...headers,
          authorization: token ? `Bearer ${token}` : "",
        }
      };
    } catch (error) {
      console.error('Error getting auth token:', error);
      return {
        headers
      };
    }
  });

  return new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
  });
};

export { createApolloClient }; 